import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import ReactBootstrapStylesheet from "./Components/ReactBootstrapStylesheet";
import App from "./app";
import "./Styles/index.css";

ReactDOM.render(
  <React.StrictMode>
    <ReactBootstrapStylesheet />
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
